<div class="agpr-panels">
    <div class="agpr-left-panel">
        <agpr-newsroom-left-sidebar
            [sidebarModel] = "sidebarModel"
            (selectionChange) = "loadPreviewPanel($event)"
            (showAmplifyDialog) = "onCreateNewStory()"
            (deleteItem) = "deleteStory($event)"
            (lazyLoad) = "fetchStories($event)"
            [totalStories] = "totalStories"
            [(start)] = "start"
            [displayRows] = "displayRows"
            [storyLoading] = "storyLoading"
            [scrollHeight] = "scrollHeight"
            [selectedItem] = "selectedItem"
            [noItemsText] = "sideBarNoItemsText"
            [itemLabel] = "sideBarItemLabel"
            [amplifyButtonLabel] = "sidebarAmplifyLabel"
            [sections] = "sidebarSections"
            [selectedSectionValue] = "sidebarSelectedSectionValue"
            (sectionChanged) = "sidebarSectionChanged($event)"
            [isFormDirty] = "routedComponent != null && routedComponent.isFormDirty()"
        >
        </agpr-newsroom-left-sidebar>
    </div>
    <div [ngClass]="[!showStoryPreview ? 'agpr-story-hypepageBackground':'']" class="agpr-story">
        <agpr-hype
            *ngIf="!showStoryPreview"
        >
        </agpr-hype>

        <router-outlet></router-outlet>
    </div>
    <agpr-newsroom-right-side-bar
        *ngIf = "showStoryPreview && routedComponent"
        [storyResponseModel] = "routedComponent.storyResponseModel"
        [rightSideBarInterface] = "routedComponent"
        [showLogoButton] = "routedComponent.showLogoButton"
        [aboutUsButtonDisabled] = "routedComponent.aboutUsButtonDisabled"
        [aboutUsButton] = "routedComponent.aboutUsButton"
        [linkButton] = "routedComponent.linkButton"
        [statusId] = "routedComponent.statusId"
        [showPublishLater] = "routedComponent.showPublishLater"
        [subjectDropDownDisabled] = "routedComponent.subjectDropDownDisabled"
        [subjectList] = "routedComponent.subjectList"
        [selectedSubject] = "routedComponent.selectedSubject"
        [reservedUrl] = "routedComponent.reservedUrl"
        [id] = "routedComponent.id"
        [isLoader] = "routedComponent.isLoader"
        [storyCreatedBy] = "routedComponent.storyCreatedBy"
        [storyModifiedBy]="routedComponent.storyModifiedBy"
        [preferences] = "routedComponent.preferences"
        [minDate] = "routedComponent.minDate"
        [remainingTextContents] = "routedComponent.remainingTextContents"
        [remainingImageContents] = "routedComponent.remainingImageContents"
    >
    </agpr-newsroom-right-side-bar>
</div>